import { Component, Prop, Emit, Mixins, Watch } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import OCRadio from './OCRadio';


@Component({
})
export default class OCRadioGroup extends Mixins(BASEComponentVue) {
    @Prop({
        type: [String, Boolean],
        default: "",
    })
    public value!: string | boolean;

    @Emit("input")
    public input(val: string | boolean) {
        return val;
    }

    public getValue() {
        return this.value;
    }

    public setValue(value: string | boolean) {
        this.input(value);
    }

}
